// removed by extract-text-webpack-plugin
module.exports = {"home-view":"YOFbewXj","homeView":"YOFbewXj","contact-button":"b2Wa2zmD","contactButton":"b2Wa2zmD"};


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/HomeView.pcss
// module id = 422
// module chunks = 0